import { gql } from '@apollo/client';

export const QUERY_FIND_ALL_BUSINESS_ENTITIES = gql`
    query FindAllBusinessEntities {
        findAllBusinessEntities {
            id
            displayName
            enabled
        }
    }
`;

export const QUERY_FIND_MANY_BUSINESS_ENTITIES = gql`
    query FindManyBusinessEntities($data: FindManyBusinessEntitiesInput!) {
        findManyBusinessEntities(data: $data) {
            id
            description
            displayName
            customDisplayName
            enabled
            entityTypes {
                id
                name
            }
            captureId
            captureLink
            createdAt
            createdBy {
                id
                name
            }
            einNumber
            freightThreshold
            level
            tagline
            images
            ownerTenant {
                id
                name
            }
            productThreshold
            representedTenant {
                id
                name
            }
            taxIdentificationNum
            updatedAt
            updatedBy {
                id
                name
            }
            associatedTenants {
                id
                name
            }
            apContact {
                id
                objectValues {
                    value
                    objectProperty {
                        name
                        isDisplayable
                        order
                    }
                }
            }
            arContact {
                id
                objectValues {
                    value
                    objectProperty {
                        name
                        isDisplayable
                        order
                    }
                }
            }
            remitTo {
                id
                objectValues {
                    value
                    objectProperty {
                        name
                        isDisplayable
                        order
                    }
                }
            }
            address {
                id
                objectValues {
                    value
                    objectProperty {
                        name
                        isDisplayable
                        order
                    }
                }
            }
            legalName
            website
            password
            customerNumber
            keyIdentifiers
            vendorNumber
            geographicLocation {
                id
                value
            }
            tagline
            logo
            images
        }
    }
`;

export const QUERY_FIND_MANY_ENTITY_TYPES = gql`
    query FindManyEntityTypes($data: FindManyEntityTypesInput!) {
        findManyEntityTypes(data: $data) {
            id
            name
        }
    }
`;

export const QUERY_GET_ENTITY_METADATA_FIELDS = gql`
    query GetEntityMetadataFields {
        getEntityMetadataFields {
            dataType
            description
            displayName
            enabled
            tag
            group
            list {
                id
            }
            objectDefinition {
                id
                name
            }
        }
    }
`;

export const QUERY_GET_FILTER_AUDIT_LOGS_FOR_ENTITY = gql`
    query FilterBusinessEntityAuditLogsForSaas($data: GetBusinessEntitySaasLogsInputPaginated!) {
        filterBusinessEntityAuditLogsForSaas(data: $data) {
            logs {
                changes {
                    oldValue
                    newValue
                    what
                }
                datetime
                action
                correlationId
                userId
                entityId
                issuer
                metadata
                tenantId
            }
            total
        }
    }
`;

export const QUERY_GET_PREFERRED_BUSINESS_ENTITIES = gql`
    query GetPreferredBusinessEntities {
        getPreferredBusinessEntities {
            preferredEntityIds
        }
    }
`;
